export default __webpack_public_path__ + "static/media/backgroundLogo.b5784f65.svg";